import { useCallback, useSyncExternalStore } from 'react';
import type { Action, AppState } from '../types';
import type { Store } from './Store';

/**
 * Subscribes to a Store and returns its current state + a stable dispatch.
 * Same shape as `useReducer` — screens can switch from one to the other without changing call sites.
 */
export function useAppState(store: Store): [AppState, (action: Action) => void] {
  const state = useSyncExternalStore(store.subscribe, store.getState);
  const dispatch = useCallback((action: Action) => store.dispatch(action), [store]);
  return [state, dispatch];
}
